import { countryCodeToFlagEmoji, getCountryName } from '@/lib/countries';
import { STOREFRONTS } from '@/lib/rankings/chart-day';

// App Store Categories with icons
export const APP_CATEGORIES = [
  { name: "Books", id: 6018, icon: "📚" },
  { name: "Business", id: 6000, icon: "💼" },
  { name: "Developer Tools", id: 6026, icon: "🛠️" },
  { name: "Education", id: 6017, icon: "🎓" },
  { name: "Entertainment", id: 6016, icon: "🎭" },
  { name: "Finance", id: 6015, icon: "💰" },
  { name: "Food & Drink", id: 6023, icon: "🍔" },
  { name: "Graphics & Design", id: 6027, icon: "🎨" },
  { name: "Health & Fitness", id: 6013, icon: "💪" },
  { name: "General", id: 36, icon: "🏆" },
  { name: "Lifestyle", id: 6012, icon: "🏡" },
  { name: "Navigation", id: 6010, icon: "🧭" },
  { name: "News", id: 6009, icon: "📰" },
  { name: "Photo & Video", id: 6008, icon: "📷" },
  { name: "Productivity", id: 6007, icon: "✅" },
  { name: "Reference", id: 6006, icon: "📖" },
  { name: "Shopping", id: 6024, icon: "🛒" },
  { name: "Social Networking", id: 6005, icon: "👥" },
  { name: "Sports", id: 6004, icon: "⚽" },
  { name: "Travel", id: 6003, icon: "✈️" },
  { name: "Utilities", id: 6002, icon: "🔧" },
  { name: "Weather", id: 6001, icon: "🌤️" }
];

// Country Codes
// Every storefront a chart is collected for, named and flagged from the code.
// The list itself lives in src/lib/rankings/chart-day.ts next to the day rules.
export const COUNTRIES: { code: string; name: string; flag: string }[] = STOREFRONTS.map((code) => ({
  code,
  name: getCountryName(code) ?? code.toUpperCase(),
  flag: countryCodeToFlagEmoji(code),
}));

// Ranking Types
export const RANKING_TYPES = [
  { id: 'top_free', name: 'Top Free' },
  { id: 'top_paid', name: 'Top Paid' },
  { id: 'top_grossing', name: 'Top Grossing' },
];

// Helper function to get category ID from name
function getCategoryIdByName(name: string): number | undefined {
  const category = APP_CATEGORIES.find(
    cat => cat.name.toLowerCase() === name.toLowerCase()
  );
  return category?.id;
}

// Helper function to get category name from ID
export function getCategoryNameById(id: number): string | undefined {
  const category = APP_CATEGORIES.find(cat => cat.id === id);
  return category?.name;
} 

// Remove known Games categories entirely from /new
export const GAME_CATEGORY_IDS = new Set<string>([
  '6014', '7001','7002','7003','7004','7005','7006','7007','7008','7009',
  '7011','7012','7013','7014','7015','7016','7017','7018','7019',
]);
